import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { ERROR } from '../../../store/types'
import { authHeader } from '../../../utils'
import axios from 'axios'
import TextareaField from '../../elements/form/TextareaField'
import ModalActionButton from '../../elements/ModalActionButton'
import NumberField from '../../elements/form/NumberField'

const ExtendExeat = ({exeat, reload, close}) => {
    const dispatch = useDispatch()
    const [remarks, setRemarks] = useState('')
    const [validationErrors, setValidationErrors] = useState({})
    const [processing, setProcessing] = useState(false)
    const [days, setDays] = useState(0)
    const validateForm = () => {
        let errors = {}
        
        if(!days || days < 1 || days === '') {
            errors.days = true
        }
  
        if(!remarks || remarks === '') {
            errors.remarks = true
        }

        setValidationErrors(errors)
        return errors
    }

    const extendExeat = async () => {
        if (Object.values(validateForm()).includes(true)) {
            dispatch({
                type: ERROR,
                error: {response: {data: {
                    message: 'Please check the highlighted fields'
                }}}
            });
            return
        }

        try {
            const headers = authHeader()

            const payload = {
                days,
                remarks
            }
            setProcessing(true)
            await axios.post(`${process.env.REACT_APP_BASE_URL}/exeats/extend/${exeat._id}`, payload, { headers })
            setProcessing(false)
            reload()
            close()
        } catch (error) {
            console.error('error declining exeat: ', error)
            dispatch({
                type: ERROR,
                error
            });
            setProcessing(false)
        }
    }

    return (
        <div className='w-full'>
            <p className='text-sm text-gray-600'>This exeat will be canceled and the student will not be able to use it any more. Please provide your remarks/reason for cancelling it in the text box below.</p>

            <div className='w-full my-2'>
                <NumberField
                    inputType="number" 
                    fieldId={`days`}
                    inputLabel="Number of days" 
                    inputPlaceholder={`Days to extend exeat by`}
                    requiredField={true}
                    preloadValue={days || ''}
                    hasError={validationErrors.days} 
                    returnFieldValue={(value)=>{setDays(value)}}
                />
            </div>

            <div className='my-2 w-full'>
                <TextareaField
                    inputLabel="Extension note/Reason" 
                    fieldId="note" 
                    inputType="text" 
                    requiredField={true}
                    inputPlaceholder="Add a note"
                    preloadValue={remarks}
                    hasError={validationErrors.remarks} 
                    returnFieldValue={(value)=>{setRemarks(value)}}
                />
            </div>

            <div className="mt-8 flex flex-row-reverse gap-x-4">
                <ModalActionButton
                    buttonLabel={`Extend Exeat`}
                    buttonAction={()=>{extendExeat()}}
                    processing={processing}
                />

                <button
                    type="button"
                    className="inline-flex justify-center px-5 py-4 text-xs font-medium bg-transparent border border-transparent rounded-md hover:bg-opacity-50 hover:bg-secondary focus:outline-none"
                    onClick={()=>{close()}}
                >
                    Close
                </button>
                
            </div>
        </div>
    )
}

export default ExtendExeat